import { getActionType } from './utils';

const initialState = {
  guardians: {},
  guardiansStudents: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case getActionType('resetGuardians'):
      return {
        ...state,
        guardians: {},
      };

    case getActionType('populateGuardians'):
      return {
        ...state,
        guardians: action.guardians,
      };

    case getActionType('populateGuardiansStudents'):
      return {
        ...state,
        guardiansStudents: action.students,
      };

    default:
      return state;
  }
};
